// Web helpers for managing the browser URL.
import { type IsoLocale } from '@repo/shared/locale';
import { getIsInIFrame, parsePsiPath } from 'util/util';

export function getIsLocalhost() {
    const commonLocalHosts = `localhost|192\\.168\\.\\d{1,3}\\.\\d{1,3}`;
    return new RegExp(commonLocalHosts).test(location.hostname);
}

export function getSiloKeyFromWindowUrl() {
    return parsePsiPath(window.location.pathname).siloKey;
}

export function getLanguageFromLoginRedirectFragment(): IsoLocale | null {
    if (getFragment().includes('state=rc')) {
        return 'fr-CA';
    }
    return null;
}

export function getThemeFromWindowUrl() {
    return new URLSearchParams(window.location.search).get('theme_g');
}

export function setTitle(title: string): void {
    window.document.title = title;
}

// True whenever PSI is embedded in a host surface: an iframe on a publisher
// page, or a native app webview panel. The webview loads PSI as the top-level
// document, so the iframe check alone misses it.
export function getIsInSidebar() {
    return getIsInIFrame(window) || getIsInPsiNativeAppWebview();
}

// This value is injected by supported native apps to indicate that the web app
// is running in a webview. See docs/native-webview.md for more information.
export function getIsInPsiNativeAppWebview() {
    return Boolean((window as any).isInPsiNativeAppWebview);
}

export function getFragment() {
    return window.location.hash;
}

export function getCanonicalUrl() {
    const { siloKey, rest } = parsePsiPath(window.location.pathname);
    const [structureKey, instanceKey] = rest;
    if (!siloKey || structureKey !== 'question' || !instanceKey || rest.length !== 2) return null;
    return window.location.origin + window.location.pathname;
}
